module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', _vm._l((_vm.issues), function(issue) {
    return _c('li', [_c('h3', {
      staticClass: "created-at"
    }, [_vm._v(_vm._s(_vm._f("moment")(issue.created_at, "MMM DD, YYYY")))]), _vm._v(" "), _c('h2', [_c('router-link', {
      attrs: {
        "to": ("/post/" + (issue.number))
      }
    }, [_vm._v(_vm._s(issue.title))])], 1)])
  })), _vm._v(" "), (_vm.isEmpty) ? _c('p', {
    staticClass: "text-center"
  }, [_vm._v("Empty")]) : _vm._e(), _vm._v(" "), _c('pager', {
    attrs: {
      "onChange": _vm.cb,
      "prevVisible": _vm.prevVisible,
      "nextVisible": _vm.nextVisible
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.2@vue-loader/lib/template-compiler?{"id":"data-v-2f2019d1"}!./~/.11.3.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/Index.vue
// module id = 155
// module chunks = 1